import { render, staticRenderFns } from "./auctionInfomation.vue?vue&type=template&id=637449ae"
import script from "./auctionInfomation.vue?vue&type=script&lang=js"
export * from "./auctionInfomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports